import css from 'styled-jsx/css';

import { gradient } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .AccountInfoPanel__wrapper {
    margin-bottom: rem(45px);
    :global(.WarningMessage) {
      margin-bottom: rem(25px);
    }
  }

  .AccountInfoPanel {
    margin-bottom: 25px;
    padding: rem(30px 30px 20px 20px);
    position: relative;
    @include respond-to(sm) {
      overflow: hidden;
    }
    :global(.LoginCell__inner) {
      :global(.LoginCell__name) {
        max-width: 90%;
        @include respond-to(xs) {
          max-width: 65%;
        }
      }
    }

    &__wallet__account {
      display: flex;
      align-items: center;
      gap: 16px;

      @include respond-to(xs) {
        gap: 8px;
      }

      &__currency {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 40px;
        min-height: 40px;
        font-weight: 500;
        border: 2px solid;
        font-size: 18px;
        border-radius: 50%;
      }

      &__title {
        font-size: 18px;
      }

      &__caption {
        font-size: 13px !important;

        @include respond-to(sm) {
          display: none !important;
        }
      }
    }

    &__caption {
      margin-bottom: 5px;
      font-size: 13px;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 100%;
      justify-content: space-between;
      li {
        display: flex;
        flex-direction: column;
        padding: rem(0 10px);
        margin-bottom: rem(15px);
        min-width: rem(115px);
        .AccountInfoPanel__second-line {
          display: flex;
          height: rem(45px);
          align-items: center;
        }
        .DefaultButton {
          margin-right: 20px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
      .Leverage__wrapper {
        min-width: auto;
      }
      .AccountInfoPanel__payments-buttons {
        flex-direction: row;
        align-items: center;
        margin-top: rem(10px);

        .DefaultButton {
          margin-bottom: 0 !important;
          margin-right: 10px;
          &:last-child {
            margin: 0;
          }

          &__text {
            color: inherit;
            margin: 0;
          }
        }
      }
    }
  }

  .AccountInfoPanel__top {
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
    }
    .AccountInfoPanel__second-line {
      p {
        font-size: rem(16px);
      }
    }
  }

  .AccountInfoPanel__bottom {
    padding: rem(20px 30px 10px 20px);
    margin: 0;
    ul {
      li {
        height: rem(67px);
        justify-content: center;
        &:first-child {
          .AccountInfoPanel__second-line {
            font-size: rem(24px);
          }
        }
      }
    }
  }

  .Account__partner-code {
    .AccountInfoPanel__second-line {
      font-size: rem(16px);
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .AccountInfoPanel {
      background-color: ${colors.white.hex};

      &__caption {
        color: ${colors.gray.hex};
      }

      &__wallet__account {
        &__currency {
          border-color: ${colors.primary.hex};
        }

        &__title {
          color: #074a6c;
        }

        &__caption {
          color: ${colors.gray.hex};
        }
      }
    }

    .AccountInfoPanel__top {
      &:after {
        background: ${gradient(90, [colors.gradientStart.rgb, 1], 0, [colors.gradientEnd.rgb, 1], 100)};
      }
    }

    .AccountInfoPanel__bottom {
      ul {
        li {
          &:first-child {
            .AccountInfoPanel__second-line {
              color: ${colors.secondary.hex};
            }
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
